import { useTranslation } from "react-i18next";
import {
  Box,
  Center,
  Text,
  useBreakpointValue,
} from "@chakra-ui/react";

export default function Footer() {
  const mainColor = "#000";
  const accentColor = "#6b4ba0";
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  const patternHeight = useBreakpointValue({ base: "80px", md: "100px" });

  const dividerWidth = useBreakpointValue({
    base: "85%", 
    sm: "75%",
    md: "60%",
    lg: "50%",
  });

  const footerData = t("footer", { returnObjects: true });

  return (
    <Box
      as="footer"
      position="relative"
      bg={mainColor}
      color="white"
      py={10}
      pb={patternHeight}
      textAlign="center"
      dir={isArabic ? "rtl" : "ltr"}
    >
      
      {/* Responsive Divider */}
      <Box
        w={dividerWidth}
        mx="auto"
        h="2px"
        bgGradient={`linear(to-r, transparent, ${accentColor}, transparent)`} 
        opacity={0.6}
        mb={{ base: 5, md: 8 }}
        borderRadius="full"
        transition="width 0.3s ease"
      />

      {/* Footer Rights Text */}
      <Center>
        <Text
          fontSize={{ base: "sm", md: "md" }}
          color="gray.200"
          letterSpacing="wide"
        >
          {footerData.rights}
        </Text>
      </Center>
    </Box>
  );
}
